export const blockIconsActivitiesHikingNew = (
	<span className='material-symbols-outlined'>hiking</span>
);
